module.exports = __webpack_public_path__ + "img/vip1.87fd8fbf.png";